import "./OutputFormat.css";
import OutputCard from "./OutputCard";

function OutputFormat(){
    const varDecl = "MODULE main\n" +
        "\n" +
        "VAR state_superstate : {nil};\n" +
        "VAR state_operator_name : {initialize,nil,rule-one,rule-two};\n" +
        "VAR state_name : {active,nil};\n" +
        "VAR state_Xval : integer;\n" +
        "VAR state_Yval : integer;";
    const varAssign = "ASSIGN\n" +
        "    init (state_operator_name) := nil;\n" +
        "    init (state_name) := nil;\n" +
        "    init (state_Xval) := 0;\n" +
        "    init (state_Yval) := 0;";
    const modDecl = "VAR soarAgent : soarRules(state_superstate, state_operator_name, state_name, state_Xval, state_Yval);\n" +
        "\n" +
        "MODULE soarRules(state_superstate, state_operator_name, state_name, state_Xval, state_Yval)\n" +
        "\n" +
        "VAR state:{start, run};";
    const modAssign = "ASSIGN\n" +
        "        init (state) := start;\n" +
        "        next (state) := \n" +
        "            case\n" +
        "        --propose*initialize (state_superstate)\n" +
        "        state = start & (state_superstate=nil) : run;\n" +
        "        --apply*initialize (state_operator_name)\n" +
        "        state = start & (state_operator_name=initialize) : run;\n" +
        "        --propose*rule-one (state_name, state_Xval)\n" +
        "        state = start & (state_name=active & state_Xval<1) : run;\n" +
        "        --apply*rule-one (state_operator_name)\n" +
        "        state = start & (state_operator_name=rule-one) : run;\n" +
        "        --propose*rule-two (state_name, state_Yval)\n" +
        "        state = start & (state_name=active & state_Yval<1) : run;\n" +
        "        --apply*rule-one (state_operator_name)\n" +
        "        state = start & (state_operator_name=rule-two) : run;\n" +
        "        state = run : start;\n" +
        "            TRUE : state;\n" +
        "            esac;"
    const trans = "TRANS\n" +
        "        next (state_operator_name) =\n" +
        "            case\n" +
        "        --propose*initialize (state_superstate)\n" +
        "        (state = run & state_superstate=nil): initialize;\n" +
        "        --propose*rule-one (state_name, state_Xval)\n" +
        "        (state = run & state_name=active & state_Xval<1): rule-one;\n" +
        "        --propose*rule-two (state_name, state_Yval)\n" +
        "        (state = run & state_name=active & state_Yval<1): rule-two;\n" +
        "            TRUE : state_operator_name;\n" +
        "            esac;\n" +
        "\n" +
        "\n" +
        "TRANS\n" +
        "        next (state_name) =\n" +
        "            case\n" +
        "        --apply*initialize (state_operator_name)\n" +
        "        (state = run & state_operator_name=initialize): active;\n" +
        "            TRUE : state_name;\n" +
        "            esac;\n" +
        "\n" +
        "\n" +
        "TRANS\n" +
        "        next (state_Xval) =\n" +
        "            case\n" +
        "        --apply*initialize (state_operator_name)\n" +
        "        (state = run & state_operator_name=initialize): 0;\n" +
        "        --apply*rule-one (state_operator_name)\n" +
        "        (state = run & state_operator_name=rule-one): 5;\n" +
        "            TRUE : state_Xval;\n" +
        "            esac;\n" +
        "\n" +
        "\n" +
        "TRANS\n" +
        "        next (state_Yval) =\n" +
        "            case\n" +
        "        --apply*initialize (state_operator_name)\n" +
        "        (state = run & state_operator_name=initialize): 0;\n" +
        "        --apply*rule-one (state_operator_name)\n" +
        "        (state = run & state_operator_name=rule-two): 5;\n" +
        "            TRUE : state_Yval;\n" +
        "            esac;";

    return (
        <div id="fmt-container">
            <h3>Translator Output:</h3>
            <div id="fmt-card-container">
                <OutputCard name="variable declaration" data={varDecl} desc="The first section of the output file declares the variables present in the model. This section also defines the type of every variable. There are 3 supported types: Integer, Real, and Symbolic Constant. If a variable is a symbolic constant, then all possible values of that variable are declared here."/>
                <OutputCard name="variable assignment" data={varAssign} desc="The second section of the output file assigns the every variable with an initial value."/>
                <OutputCard name="module declaration" data={modDecl} desc="This section of the output file declares a module that represents the SOAR program in NuXmv. It also declares which variables the module can access."/>
                <OutputCard name="module assignment" data={modAssign} desc="This section of the output file is used to model the propose and apply phases of the SOAR cycle in NuXmv. This section uses the 'state' variable to determine whether propose-rules should fire, or if apply-rules should fire."/>
                <OutputCard name="transition statements" data={trans} desc="This last section of the output file is where the bulk of the logic resides. In this section, every variable gets its own transition section. These transition sections define how a variable changes and what conditions will cause a variable to change its value. To assist the user with debugging, comments containing the name of the original SOAR rule from which a transition statement is generated from, are inserted next to each statement."/>
            </div>
        </div>
    );
}

export default OutputFormat;